import React from 'react';

import ModelTypeConstants from 'constants/ModelTypeConstants';
import {LeafType, isBenchlingTypeDefList} from 'data-types/benchling-type-def/BenchlingTypeDef';
import SearchInput from 'search/inputs/SearchInput';

import {ValueInputProps} from './ValueInputTypes';

/**
 * @package
 */
export default function DatasetValueInput({
  allowAutoFocus,
  onChange,
  typeDef,
  valueInput,
  disabled,
  hideSelectedResults,
}: ValueInputProps<LeafType.DATASET>): JSX.Element {
  const value = valueInput.isValid ? valueInput.value : null;
  const isMulti = isBenchlingTypeDefList(typeDef);
  const selected = value == null ? [] : Array.isArray(value) ? value : [value];

  return (
    <SearchInput
      autoFocus={allowAutoFocus}
      disabled={disabled}
      disableTyping={!isMulti && value != null}
      hideSelectedResults={hideSelectedResults}
      isMulti={isMulti}
      onRemove={(itemId) => {
        if (isMulti) {
          const newValue = selected.filter((id) => id !== itemId);
          onChange(newValue.length > 0 ? newValue : []);
        } else {
          onChange(null);
        }
      }}
      onSelect={(itemId) => {
        if (isMulti) {
          onChange([...selected, itemId].filter((id): id is string => id != null));
        } else {
          onChange(itemId);
        }
      }}
      placeholder=""
      selected={selected.filter((id): id is string => id != null)}
      types={[ModelTypeConstants.DATASET]}
    />
  );
}
